import { NavLink, Outlet } from 'react-router-dom'
import { Users, Coins, Megaphone } from 'lucide-react'
import { useMe } from '../lib/me.js'
import { canAccessStaff } from '../lib/role.js'

// Horizontal tab shell for Manager › ทันตแพทย์ (mirrors EmployeeLayout/ChartLayout).
// All tabs sit behind the Manager-area gate; the income tab's WRITE actions are
// narrower still (Manager/Admin — see the page).
//
// ⚠️ ประกาศ carries its own `gate`. The Manager area admits Stock Manager, but
// its proxies live under /api/hr/* which the middleware refuses to Stock Manager
// — so without this the tab would load and then 403 on every call. The gate and
// the proxy prefix have to agree; if ประกาศ ever moves off /api/hr, revisit this.
const TABS = [
  { to: 'list',   label: 'รายชื่อ',            icon: Users, hint: 'ข้อมูลหมอ ความเชี่ยวชาญ และสถานะ' },
  { to: 'income', label: 'จัดการรายได้แพทย์', icon: Coins, hint: 'สรุป DF ค่า Lab และยอดโอนรายเดือน' },
  { to: 'broadcast', label: 'ประกาศ', icon: Megaphone, hint: 'ส่งประกาศถึงทันตแพทย์', gate: canAccessStaff },
]

export default function DentistLayout() {
  const me = useMe()
  const tabs = TABS.filter((t) => !t.gate || t.gate(me))
  return (
    <div className="px-10 py-8">
      <h1 className="text-[22px] font-semibold text-slate-900 tracking-tight mb-1">ทันตแพทย์</h1>
      <p className="text-[13.5px] text-slate-500 mb-4">ข้อมูลหมอ รายได้รายเดือน และประกาศถึงทันตแพทย์</p>

      <div className="border-b border-slate-200 -mx-1 mb-6">
        {/* no-scrollbar: keep the row scrollable on a narrow window but hide the
            bar — with two short tabs it never needs to scroll, and the track was
            showing as a stray line beside the tabs. */}
        <nav className="flex items-end gap-1 px-1 overflow-x-auto no-scrollbar">
          {tabs.map(({ to, label, icon: Icon, hint }) => (
            <NavLink
              key={to}
              to={`/manager/dentist/${to}`}
              title={hint}
              className={({ isActive }) =>
                `relative flex items-center gap-1.5 px-3 py-2.5 text-[14px] font-medium whitespace-nowrap transition-colors ${
                  isActive ? 'text-brand-700' : 'text-slate-500 hover:text-slate-900'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={14} strokeWidth={1.75} />
                  <span>{label}</span>
                  {isActive && <span className="absolute left-2 right-2 -bottom-px h-[2px] bg-brand-600 rounded-full" />}
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  )
}
